
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { Carousel } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import carousel_01 from '../../../assets/img/carousel/carousel_img1.jpg';
import carousel_02 from '../../../assets/img/carousel/carousel_img2.png';
import carousel_03 from '../../../assets/img/carousel/carousel_img3.png';
import carousel_04 from '../../../assets/img/carousel/carousel_img4.png';
import carousel_05 from '../../../assets/img/carousel/carousel_img5.jpg';
import carousel_06 from '../../../assets/img/carousel/carousel_img6.jpg';
import carousel_07 from '../../../assets/img/carousel/carousel_img7.jpg';

/**
 * Note: Your components tell React what you want to render
 */
class AppCarousel extends React.Component {
	render() {
		return (
			 <Carousel>

			 	<Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_01} />
		      <Carousel.Caption>
		        <h1>Tracy Steven Brown</h1>
		        <h3>Senior Professional Appointment - University of Arizona</h3>
		        <h4>React.js &amp; React-Bootstrap Portfolio Website - Native npm App Compiled with Babel</h4>
		      </Carousel.Caption>
		    </Carousel.Item>

			 	<Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_02} />
		      <Carousel.Caption>
		        <h2>Algorithms (C-Language)</h2>
		        <h4>An example of an advanced data structure composed of tables called a lattice</h4>
		      	{ /* <h2>Storyboarding DxPackages</h2> */ }
		        { /* <h4>'DxPackages' are prototype conceptual health informatics software for practitioners</h4> */ }
		      </Carousel.Caption>
		    </Carousel.Item>

		    <Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_03} />
		      <Carousel.Caption>
		        <h2>Front-End Web/Multimedia</h2>
		        <h4>ActionScript (Abode Flash/Flex) front-end code handling XML data requests from a webserver</h4>
		      	{ /* <h2>Conceptualizing Data</h2> */ }
		        { /* <h4>Applying statistical confidence intervals to patient lab data</h4> */ }
		      </Carousel.Caption>
		    </Carousel.Item>

				<Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_04} />
		      <Carousel.Caption>
		        <h2>Java/Applet</h2>
		        <h4>Java Applet to mediate requests to and from a webserver</h4>
		       	{ /* <h2>Experimental Visualization</h2> */ }
		        { /* <h4>Working out conceptual visualization for complex patient data</h4> */ }
		      </Carousel.Caption>
		    </Carousel.Item>

				<Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_05} />
		      <Carousel.Caption>
		        <h2>C#/SQLite Project</h2>
		        <h4>A sample C#/SQLite personal project</h4>
		      </Carousel.Caption>
		    </Carousel.Item>

		    <Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_06} />
		      <Carousel.Caption>
		        <h2>Database Development T-SQL</h2>
		        <h4>Example T-SQL code - reworked for public consumption</h4>
		      </Carousel.Caption>
		    </Carousel.Item>

		    <Carousel.Item>
		      <img className="img-responsive center-block img-fluid" width={1600} height={900} alt="1600x900" src={carousel_07} />
		      <Carousel.Caption>
		        <h2>ANTLR HTTP Grammar</h2>
		        <h4>Tracy's HTTP Lexical Grammar</h4>
		      </Carousel.Caption>
		    </Carousel.Item>

			</Carousel>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppCarousel;

/*
			 	<AppCarouselItem img={carousel_07} heading="ANTLR HTTP Grammar" subheading="Tracy's HTTP Lexical Grammar" />
*/


// WEBPACK FOOTER //
// ./src/cba/appspec/carousel/AppCarousel.js